var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H10.1633V28.5413C10.1633 31.0037 8.11236 33 5.58163 33C3.0509 33 1 31.0037 1 28.5413V1Z",
    stroke: "white",
    strokeWidth: 1.31904,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.084 25.6865L29.4039 15.8795C29.6703 15.7193 29.7546 15.3768 29.592 15.1143L24.8196 7.40941C24.6571 7.14695 24.3093 7.064 24.0428 7.22412L12.9805 13.8718L12.9918 15.1691L18.1816 12.0504L22.3658 18.8047L13.0727 24.3891L13.084 25.6865ZM19.1466 11.4706L24.149 8.46447L28.3327 15.219L23.3307 18.2248L19.1466 11.4706Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.091 32.2564L13.0898 31.143L24.8787 31.1438L24.8787 23.2315L17.11 23.2315C16.7978 23.2315 16.5448 22.9823 16.5448 22.6748C16.5448 22.3674 16.7978 22.1182 17.11 22.1182L32.4342 22.1186C32.7463 22.1186 32.9993 22.3679 32.9993 22.6753L32.9988 31.7009C32.9987 32.0084 32.7457 32.2576 32.4336 32.2576L13.091 32.2564ZM26.009 31.1438V23.2315L31.869 23.2319L31.8685 31.1442L26.009 31.1438Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35374 28.487C4.35374 27.8294 4.89615 27.2856 5.58011 27.2856C6.26407 27.2856 6.80648 27.8294 6.80648 28.487C6.80648 29.1446 6.26407 29.6883 5.58011 29.6883C4.89615 29.6883 4.35374 29.1446 4.35374 28.487Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.879359
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon-6.7bdab75c05e7ee210ddf21a9b7ac4ee3.svg";
export { ForwardRef as ReactComponent };